import { Link } from 'react-router-dom';
import Icon from './Icon.jsx';

/**
 * 章節標頭：英文 eyebrow + 中文 title + 右側「全部 →」連結。
 *
 * @param eyebrow   上方英文小標
 * @param title     主標題
 * @param linkTo    右側連結網址
 * @param linkText  右側連結文字（預設「全部商品」）
 */
function SectionHeader({ eyebrow, title, linkTo, linkText = '全部商品' }) {
  return (
    <div className="section-head">
      <div>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h2 className="section-title">{title}</h2>
      </div>
      {linkTo && (
        <Link className="section-link" to={linkTo}>
          {linkText} <Icon name="arrow" size={16} />
        </Link>
      )}
    </div>
  );
}

export default SectionHeader;
